import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Screenshare = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <rect
          x='2.094'
          y='4.416'
          width='20'
          height='16'
          rx='3'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.094 15.416v-6m0 0 2.5 2.5m-2.5-2.5-2.5 2.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.094 4.416a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3zm7.53 4.47a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.22-1.22v4.19a.75.75 0 1 0 1.5 0v-4.19l1.22 1.22a.75.75 0 0 0 1.06-1.06z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
